import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, forwardRef, useImperativeHandle, useRef, } from 'react';
import clsx from 'clsx';
import { MenuList } from '../../components/MenuList';
export const EmojiList = forwardRef(({ items, command }, ref) => {
    const refs = useRef([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const selectItem = index => {
        const item = items[index];
        if (item) {
            command(item);
        }
    };
    const upHandler = () => {
        setSelectedIndex((selectedIndex + items.length - 1) % items.length);
    };
    const downHandler = () => {
        setSelectedIndex((selectedIndex + 1) % items.length);
    };
    const enterHandler = () => {
        selectItem(selectedIndex);
    };
    useEffect(() => setSelectedIndex(0), [items]);
    useEffect(() => {
        const el = refs.current[selectedIndex];
        if (el) {
            el.scrollIntoView({
                behavior: 'auto',
                block: 'nearest',
                inline: 'start',
            });
        }
    }, [selectedIndex]);
    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                upHandler();
                return true;
            }
            if (event.key === 'ArrowDown') {
                downHandler();
                return true;
            }
            if (event.key === 'Enter') {
                enterHandler();
                return true;
            }
            return false;
        },
    }));
    if (!items || items.length === 0) {
        return null;
    }
    return (_jsx(MenuList, { children: items.map((item, index) => (_jsxs("span", { ref: el => {
                refs.current[index] = el;
            }, className: clsx(index === selectedIndex
                ? 'bg-surface-subdued text-content'
                : 'bg-surface text-content', 'flex items-center px-4 py-2 space-s-2 w-56', 'cursor-pointer'), onClick: () => selectItem(index), children: [_jsx("span", { children: item.native }, void 0), _jsx("div", { className: "truncate", children: item.shortcodes }, void 0)] }, item.id))) }, void 0));
});
//# sourceMappingURL=EmojiList.js.map